import { gql } from '@apollo/client';

const SearchAreaSuggestQuery = gql`
  query SearchAreaSuggestQuery(
    $query: String!
    $first: Int!
    $enabled: Boolean
  ) {
    searchAreaSuggest(query: $query, first: $first, enabled: $enabled) {
      edges {
        node {
          description
          id
          name
          path
          statisticalAreas {
            id
          }
        }
      }
    }
  }
`;

export default SearchAreaSuggestQuery;
